export default __webpack_public_path__ + "static/media/Image-14.1e3e8691.jpg";